import React from "react";

// Banner on the map while a historic analysis is open
const ViewedBanner = ({ reference, onClose }) => (
  <div className="viewed-banner" role="status">
    <span>
      Analyse historique · <b>{reference}</b>
    </span>
    <button type="button" onClick={onClose} aria-label="Fermer l’analyse historique">
      ×
    </button>
  </div>
);

export default ViewedBanner;
